import { Divider, List, ListSubheader, Typography } from "@mui/material";
import { SeasonOne } from "../dataset/episode_data";
import { EpisodeTile } from "../views/episode_tile";

export const EpisodesPage: React.FC = () => {
    return <List>
        <ListSubheader>
            <Typography variant="button" fontWeight="bold">
                Season One
            </Typography>
            <Divider />
        </ListSubheader>
        {
            SeasonOne.map((episode, index) => <>
                <EpisodeTile episode={episode} episodeNumber={index + 1} />
                {index === SeasonOne.length - 1
                    ? null
                    : <Divider />
                }
            </>
            )
        }
    </List >;
}